<template>
    <section class="home-page flex flex-col items-center p-5">
        <img src="../assets/pomps_icon.png" alt="pomp's logo" class="h-44 mb-2 object-cover"/>
        <h1 class="font-pbold text-2xl mb-5">Welcome to the Pomps Emergency Roadside Service App</h1>
        <div class="admin flex items-center mb-3">
            <h1 class="mr-3 font-pmedium">Admin? -></h1>
            <AdminLogin />
        </div>
        <div class="select-section w-1/4">  
            <Select :class="'bg-gray-100'" v-model:model-value="selectedCustomer">
                <SelectTrigger :class="'bg-gray-100'" class="w-full font-pregular">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        <SelectItem v-for="customer in customers" :value=customer.url_label multiple=true class="font-pregular cursor-pointer border border-white hover:bg-green-100 hover:border hover:border-green-700">
                            {{ customer.name }}
                        </SelectItem>
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    </section>
</template>

<script setup lang="ts">
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import AdminLogin from '@/components/admin/AdminLogin.vue'
import { ref, watch, onMounted } from 'vue';
import * as Sentry from "@sentry/vue";
import { useRouter } from 'vue-router';
import { customerService } from '@/services/customerService';
import type { SelectedCustomer } from '@/types';

// Was previously its own independent Firestore onSnapshot query (duplicated
// logic already living in customerService/useCustomerStore). Now a one-time
// fetch through the same API used everywhere else -- no live/real-time
// updates, matching how ers-api doesn't support push today.
const customers = ref<SelectedCustomer[]>([])
onMounted(async () => {
    try {
        customers.value = await customerService.getAll()
    } catch (error) {
        Sentry.captureException(error)
    }
})

const selectedCustomer = ref<string>()
watch(selectedCustomer, async(newValue, oldValue) => {
    if(newValue && selectedCustomer.value) {
        goToCustomer(selectedCustomer.value)
    }
})
const router = useRouter()
function goToCustomer(c: string) {
    router.push({ name: "Customer", params: { customer: c } })
}
</script>